// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3D9uL","footer":"styles_footer__32PSl","passCodeTooltip":"styles_passCodeTooltip__xsx4c"};